

export const getFilterFieldType = (type?: string): string => {
    if (!type) return 'text'

    const lowerType = type.toLowerCase()

    if (lowerType === 'date' || lowerType === 'custom_date') {
        return 'date'
    }

    return lowerType || 'text'
}